import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { RosterRunHistoryEntryRestService } from "@app/services/hal/roster/roster-run-history-entry-rest-service";
import { RosterRunHistoryEntry } from "@app/models/rest/roster/roster-run-history-entry";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class RosterRunHistoryEntryStore extends RealTimeDataStore<RosterRunHistoryEntry> {
  constructor() {
    const rosterRunHistoryEntryRestService = inject(
      RosterRunHistoryEntryRestService
    );
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      rosterRunHistoryEntryRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("RosterRunHistoryEntry");
  }
}
